var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.364,
    viewBox: "0 0 16 13.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Archive",
    d: "M2,3.75A.75.75,0,0,1,2.75,3h14.5a.75.75,0,0,1,.75.75v3.3a.75.75,0,0,1-.75.75h-.568v7.818a.75.75,0,0,1-.75.75H4.068a.75.75,0,0,1-.75-.75V7.8H2.75A.75.75,0,0,1,2,7.045ZM15.932,6.3H16.5V4.5H3.5V6.3H15.932Zm-.75,1.5H4.818v7.068H15.182Zm-6.5,1.136a.75.75,0,1,0,0,1.5h2.636a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-2 -3)",
    fill: "#373737",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFolder);
export default __webpack_public_path__ + "static/media/upload-folder.c243d7d9b6847a199418f8ee30e9e5bd.svg";
export { ForwardRef as ReactComponent };